<template>
	<div>
		<v-card class="shadowCard text--center">
			<v-img src="@/assets/backgrounds/encuesta_satis.jpg"
				class="align-center"
			>
				<v-card-title>
					<v-spacer></v-spacer>
			  	<span class="text-h5 text--center white--text" align="center">Encuesta de satisfacción</span>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-actions>
					<v-spacer></v-spacer>
					<a class="more-link text-caption" @click="dialogEncuesta = true">Contestar encuesta</a>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-img>
		</v-card>

		<v-dialog
      v-model="dialogEncuesta"
      persistent
      max-width="400"
    >
    	<v-card
		    class="mx-auto"
		    max-width="500"
		  >
		    <v-card-title class="text-h6 font-weight-regular justify-space-between">
		      <span>Encuesta de satisfacción</span>
		      <v-avatar
		        color="primary"
		        class="subheading white--text"
		        size="24"
		        v-text="step"
		      ></v-avatar>
		    </v-card-title>

		    <v-window v-model="step">
		      <v-window-item :value="1">
		        <v-card-text>
		          <div v-for="(pregunta, i ) in preguntasSeccion1" :key="i">
		        		{{ pregunta.pregunta }}

		        		<!-- PREGUNTAS CON OPCIONES -->
		        		<span v-if="pregunta.tipo_pregunta != 2 ">

		        			<!-- Preguntas de ua sola opción -->
		      				<v-radio-group
		      					v-if="pregunta.tipo_pregunta == 1"
							      v-model="pregunta.respuesta"
							      column
							      dense
							    >
							      <v-radio
							      	v-for="(opcion, j ) in pregunta.opciones" 
							      	:key="j"
							        :label="opcion.opcion"
							        :value="opcion.idopc_enc_satis"
							      ></v-radio>
							    </v-radio-group>

							    <!-- PREGUNTAS CON MULTIPLE RESPUESTA -->
							    <span v-else>
							    	<v-checkbox
							    		v-for="(opcion, j ) in pregunta.opciones" 
							    		:key="j"
						          v-model="opcion.respuesta"
						          hide-details
						          class="shrink mr-2 mt-0"
						        >
						        	<template v-slot:label>
								        <div>
								          {{ opcion.opcion }}
								        </div>
							      	</template>
						        </v-checkbox>
							    </span>
		      			</span>
		      			<!-- PREGUNTA ABIERTA -->
		      			<span v-else>
		      				<v-textarea
		      					v-model="pregunta.respuesta"
		      					label="respuesta"
		      					dense
		      					filled
		      					hide-details
		      					rows="3"
		      				/>
		      			</span>
		      			<v-divider></v-divider>
		        		<br/>
		        	</div>
		        </v-card-text>
		      </v-window-item>

		      <v-window-item :value="2">
		        <v-card-text>
		        	<div v-if="teachers"><b>TEACHER: {{ teachers.teacher1.teacher.toUpperCase() }} </b></div><br/>
		          <div v-for="(pregunta, i ) in preguntasTeachers1" :key="i">
		        		{{ pregunta.pregunta }}

		        		<!-- PREGUNTAS CON OPCIONES -->
		        		<span v-if="pregunta.tipo_pregunta != 2 ">

		        			<!-- Preguntas de ua sola opción -->
		      				<v-radio-group
		      					v-if="pregunta.tipo_pregunta == 1"
							      v-model="pregunta.respuesta"
							      column
							      dense
							    >
							      <v-radio
							      	v-for="(opcion, j ) in pregunta.opciones" 
							      	:key="j"
							        :label="opcion.opcion"
							        :value="opcion.idopc_enc_satis"
							      ></v-radio>
							    </v-radio-group>

							    <!-- PREGUNTAS CON MULTIPLE RESPUESTA -->
							    <span v-else>
							    	<v-checkbox
							    		v-for="(opcion, j ) in pregunta.opciones" 
							    		:key="j"
						          v-model="opcion.respuesta"
						          hide-details
						          class="shrink mr-2 mt-0"
						        >
						        	<template v-slot:label>
								        <div>
								          {{ opcion.opcion }}
								        </div>
							      	</template>
						        </v-checkbox>
							    </span>
		      			</span>
		      			<!-- PREGUNTA ABIERTA -->
		      			<span v-else>
		      				<v-textarea
		      					v-model="pregunta.respuesta"
		      					label="respuesta"
		      					dense
		      					filled
		      					hide-details
		      					rows="3"
		      				/>
		      			</span>
		      			<v-divider></v-divider>
		        		<br/>
		        	</div>
		        </v-card-text>
		      </v-window-item>

		      <v-window-item :value="3">
		        <v-card-text>
		        	<div v-if="teachers"><b>TEACHER: {{ teachers.teacher2.teacher.toUpperCase() }}</b> </div><br/>

		          <div v-for="(pregunta, i ) in preguntasTeachers2" :key="i">
		        		{{ pregunta.pregunta }}

		        		<!-- PREGUNTAS CON OPCIONES -->
		        		<span v-if="pregunta.tipo_pregunta != 2 ">

		        			<!-- Preguntas de ua sola opción -->
		      				<v-radio-group
		      					v-if="pregunta.tipo_pregunta == 1"
							      v-model="pregunta.respuesta"
							      column
							      dense
							    >
							      <v-radio
							      	v-for="(opcion, j ) in pregunta.opciones" 
							      	:key="j"
							        :label="opcion.opcion"
							        :value="opcion.idopc_enc_satis"
							      ></v-radio>
							    </v-radio-group>

							    <!-- PREGUNTAS CON MULTIPLE RESPUESTA -->
							    <span v-else>
							    	<v-checkbox
							    		v-for="(opcion, j ) in pregunta.opciones" 
							    		:key="j"
						          v-model="opcion.respuesta"
						          hide-details
						          class="shrink mr-2 mt-0"
						        >
						        	<template v-slot:label>
								        <div>
								          {{ opcion.opcion }}
								        </div>
							      	</template>
						        </v-checkbox>
							    </span>
		      			</span>
		      			<!-- PREGUNTA ABIERTA -->
		      			<span v-else>
		      				<v-textarea
		      					v-model="pregunta.respuesta"
		      					label="respuesta"
		      					dense
		      					filled
		      					hide-details
		      					rows="3"
		      				/>
		      			</span>
		      			<v-divider></v-divider>
		        		<br/>
		        	</div>
		        </v-card-text>
		      </v-window-item>

		      <v-window-item :value="4">
		        <v-card-text>
		          <div v-for="(pregunta, i ) in preguntasSeccion3" :key="i">
		        		{{ pregunta.pregunta }}

		        		<!-- PREGUNTAS CON OPCIONES -->
		        		<span v-if="pregunta.tipo_pregunta != 2 ">

		        			<!-- Preguntas de ua sola opción -->
		      				<v-radio-group
		      					v-if="pregunta.tipo_pregunta == 1"
							      v-model="pregunta.respuesta"
							      column
							      dense
							    >
							      <v-radio
							      	v-for="(opcion, j ) in pregunta.opciones" 
							      	:key="j"
							        :label="opcion.opcion"
							        :value="opcion.idopc_enc_satis"
							      ></v-radio>
							    </v-radio-group>

							    <!-- PREGUNTAS CON MULTIPLE RESPUESTA -->
							    <span v-else>
							    	<v-checkbox
							    		v-for="(opcion, j ) in pregunta.opciones" 
							    		:key="j"
						          v-model="opcion.respuesta"
						          hide-details
						          class="shrink mr-2 mt-0"
						        >
						        	<template v-slot:label>
								        <div>
								          {{ opcion.opcion }}
								        </div>
							      	</template>
						        </v-checkbox>
							    </span>
		      			</span>
		      			<!-- PREGUNTA ABIERTA -->
		      			<span v-else>
		      				<v-textarea
		      					v-model="pregunta.respuesta"
		      					label="respuesta"
		      					dense
		      					filled
		      					hide-details
		      					rows="3"
		      				/>
		      			</span>
		      			<v-divider></v-divider>
		        		<br/>
		        	</div>
		        </v-card-text>
		      </v-window-item>
		    </v-window>

		    <v-divider></v-divider>

		    <v-card-actions>
		    	<v-btn
		      	v-if="step == 1"
		        text
		        @click="dialogEncuesta = false"
		        dense
		        rounded
		      >
		        Cancelar
		      </v-btn>

		      <v-btn
		      	v-if="step > 1"
		        :disabled="step === 1"
		        text
		        @click="step--"
		        dense
		        rounded
		      >
		        Regresar
		      </v-btn>
		      <v-spacer></v-spacer>
		      <v-btn
		        v-if="step < 4"
		        color="primary"
		        depressed
		        @click="avanzarStep()"
		        dense
		        rounded
		      >
		        Siguiente
		      </v-btn>

		      <v-btn
		        v-if="step === 4 && bloquear == false"
		        color="primary"
		        depressed
		        @click="save()"
		        dense
		        rounded
		      >
		        Enviar
		      </v-btn>
		    </v-card-actions>
		  </v-card>
    </v-dialog>

    <Alerta   v-if="respuestaAlerta" :parametros="parametros"/>
		<Loader   v-if="cargar"          :loader="cargar"/>

	</div>
</template>
<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
	import { Clipboard } from '@capacitor/clipboard';
  import { Share } from '@capacitor/share';

  import  validarErrores from '@/mixins/validarErrores.js';

  // Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

	export default {
		components:{
  		Alerta,
  		Loader
  	},

		props:[
			'encuestaSatis'
	  ],

  	mixins:[validarErrores],


	  data: () => ({
	  	cargar: false,
			parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

     	respuestaAlerta:false,

	  	dialogEncuesta: false,
	  	persona_beca:null,
	  	nombre: null,
	  	dialogCopiarEnlace: false,
	  	show: false,
	  	mensajeTooltip: '',

	  	preguntasSeccion1 : [],
	  	preguntasTeachers1: [],
	  	preguntasTeachers2: [],
	  	preguntasSeccion3 : [],
	  	step: 1,
	  	grupoActivo: null,
	  	teachers: null,
	  	bloquear:false
	  }),

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    created() {
    	this.initialize()
    },

    methods:{
    	initialize( ){
    		this.cargar = true
    		this.$http.get('encuestas.satisfaccion/' + this.getUsuarioLMS.id ).then( response => {
      		this.preguntasSeccion1  = response.body.preguntasSeccion1
      		this.preguntasSeccion3  = response.body.preguntasSeccion3
      		this.preguntasTeachers1 = response.body.preguntasTeachers1
      		this.preguntasTeachers2 = response.body.preguntasTeachers2
      		this.grupoActivo        = response.body.grupoActivo
      		this.teachers           = response.body.teachers 
      		this.cargar = false
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
    	},

      async save( ){
      	this.cargar = true
      	this.bloquear = true
      	const payload = {
      		id_alumno:          this.getUsuarioLMS.id,
      		preguntasSeccion1:  this.preguntasSeccion1,
      		preguntasSeccion3:  this.preguntasSeccion3,
      		preguntasTeachers1: this.preguntasTeachers1,
      		preguntasTeachers2: this.preguntasTeachers2,
      		grupoActivo:        this.grupoActivo,
      		teachers:           this.teachers, 
      	}

      	this.$http.post('encuestas.satisfaccion', payload ).then( response => {
      		this.validarSuccess( response.body.message )
      		var me = this
      		setTimeout(function(){ me.cargar = false; me.encuestaSatis.visible = false }, 2000);
        }).catch( error =>{
        	this.bloquear = false
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      avanzarStep( ){
      	if( this.teachers.teacher1.id_teacher == this.teachers.teacher2.id_teacher ){
      		if( this.step == 1 ){
      			this.step += 1
      		}else{
      			this.step += 2
      		}
      	}else{
      		this.step += 1
      	}
      },

      async copiarPortapapeles( ){
      	window.open('https://fastenglish.com.mx/conoce-tu-nivel-de-ingles-ceaa/')
      }

    }
  }
</script>



<style scoped>
  /* Demo Stuff */
  a.more-link {
    background-color: rgba(255, 255, 255, 0.35);
    display: inline-block;
    padding: 12px 18px;
    color: #fff;
    text-decoration: none;
    font: 500 15px 'Work Sans', Helvetica, sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none !important;
    position: relative;
    border-radius: 30px;
    text-transform: uppercase;
    -webkit-transition: .1s all ease-in-out;
    -moz-transition: .1s all ease-in-out;
    -o-transition: .1s all ease-in-out;
    transition: .1s all ease-in-out;
  }
  a.more-link:hover {
    background-color: rgba(255, 255, 255, 0.50);
  }
  
  .link-container {
    text-align: center;
  }
  .link-container a.more-link {
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    background-color: #90b0bf;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    letter-spacing: 1px;
  }


  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button:increment,.v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button{
    display: none;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

</style>